import React from 'react';
import { Text, StyleSheet, View } from 'react-native';
import GenericButton from '../../../../components/molecules/buttons/GenericButton';
import EmptyCredentialIcon from '../../../../components/icons/EmptyCredentialIcon';
import { IUser } from '../../../../types/user';

interface IEmptyCredentialProps {
  user: IUser;
  setSendUserCredModalOpen: (value: boolean) => void;
}

/**
 * EmptyCredential component
 *
 * @param {*} { user, setSendUserCredModalOpen }
 * @return {*}
 */
const EmptyCredential: React.FC<IEmptyCredentialProps> = ({ user, setSendUserCredModalOpen }) => {
  return (
    <View style={styles.emptyCredentialContainer}>
      <EmptyCredentialIcon />
      <Text style={styles.emptyTitle}>No Credentials Found</Text>
      <Text style={styles.emptySubText}>{user?.tenant_name} doesn't have any credentials yet.</Text>
      <Text style={styles.emptySubText}>Get started by issuing their first credential.</Text>
      <GenericButton
        title={'Issue Credential'}
        onPress={() => setSendUserCredModalOpen(true)}
        buttonStyle={styles.button}
        textStyle={styles.buttonText}
        isPrimary={true}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  emptyCredentialContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 40,
    paddingHorizontal: 20,
    gap: 16
  },
  emptyTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#495057',
    textAlign: 'center'
  },
  emptySubText: {
    fontSize: 16,
    fontWeight: '400',
    color: '#6c757d',
    textAlign: 'center',
    lineHeight: 22
  },
  button: {
    width: 150,
    height: 44,
    borderRadius: 8,
    backgroundColor: '#007bff',
    marginTop: 8
  },
  buttonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff'
  }
});

export default EmptyCredential;
